import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import transportRouteAPI from '@infrastructure/transport-route-api';
export const getRoutesByEventIdAsync = createAsyncThunk('transportRoute/getByEventId', async ({ eventId, query }, { rejectWithValue }) => {
    try {
        const response = await transportRouteAPI.getRoutesByEventId(eventId, query);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createRouteAsync = createAsyncThunk('transportRoute/create', async (request, { rejectWithValue }) => {
    try {
        const response = await transportRouteAPI.createRoute(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateRouteAsync = createAsyncThunk('transportRoute/update', async (request, { rejectWithValue }) => {
    try {
        const response = await transportRouteAPI.updateRoute(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteRouteAsync = createAsyncThunk('transportRoute/delete', async (id, { rejectWithValue }) => {
    try {
        await transportRouteAPI.deleteRoute(id);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const addPickupLocationToRouteAsync = createAsyncThunk('transportRoute/addPickupLocation', async (request, { rejectWithValue }) => {
    try {
        await transportRouteAPI.addPickupLocationToRoute(request);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const addVehicleToRouteAsync = createAsyncThunk('transportRoute/addVehicle', async (request, { rejectWithValue }) => {
    try {
        await transportRouteAPI.addVehicleToRoute(request);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getRouteByIdAsync = createAsyncThunk('transportRoute/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await transportRouteAPI.getRouteById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const removePickupLocationFromRouteAsync = createAsyncThunk('transportRoute/removePickupLocation', async ({ routeId, pickupLocationId }, { rejectWithValue }) => {
    try {
        await transportRouteAPI.removePickupLocationFromRoute(routeId, pickupLocationId);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const removeVehicleFromRouteAsync = createAsyncThunk('transportRoute/removeVehicle', async ({ routeId, vehicleId }, { rejectWithValue }) => {
    try {
        await transportRouteAPI.removeVehicleFromRoute(routeId, vehicleId);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const reorderRouteStopsAsync = createAsyncThunk('transportRoute/reorderStops', async ({ routeId, stops }, { rejectWithValue }) => {
    try {
        const response = await transportRouteAPI.reorderRouteStops(routeId, stops);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
